<app-header *ngIf="!isHome"></app-header>
<mat-sidenav-container class="sidenav-container" autosize [ngClass]="{'isHome':isHome}">
  <mat-sidenav mode="side" [opened]="isExpanded" *ngIf="!isHome">
    <app-sidebar></app-sidebar>
  </mat-sidenav>
  <mat-sidenav-content class="sidenav-main-content" id="pageTop">
    <app-loader></app-loader>
    <router-outlet />
  </mat-sidenav-content>
</mat-sidenav-container>